// extracted by mini-css-extract-plugin
module.exports = {"outsideContainer":"style_outsideContainer__TGLZO","childrenContainer":"style_childrenContainer__ZS__i"};